import * as React from "react";

const SvgTicket = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M21 10v1a1 1 0 0 0 1-1h-1ZM21 14h1a1 1 0 0 0-1-1v1ZM3 14v-1a1 1 0 0 0-1 1h1ZM3 10H2a1 1 0 0 0 1 1v-1ZM5 4a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1V4ZM19 4H5v2h14zM22 7a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2ZM22 10V7h-2v3z"
        fill={color}
        fillRule="nonzero"
      />
      <path
        d="M20 12a1 1 0 0 1 1-1V9a3 3 0 0 0-3 3h2ZM21 13a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3v-2Z"
        fill={color}
        fillRule="nonzero"
      />
      <path
        fill={color}
        fillRule="nonzero"
        d="M22 17v-3h-2v3zM19 20a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1v2ZM5 20h14v-2H5zM2 17a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1H2ZM2 14v3h2v-3z"
      />
      <path
        d="M4 12a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3H4ZM3 11a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2Z"
        fill={color}
        fillRule="nonzero"
      />
      <path fill={color} fillRule="nonzero" d="M2 7v3h2V7z" />
      <path
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        d="M15.5 5v2M15.5 11v2M15.5 17v2"
      />
    </g>
  </svg>
);

export default SvgTicket;
